import { render, staticRenderFns } from "./HiddenInput.vue?vue&type=template&id=6312c399"
import script from "./HiddenInput.vue?vue&type=script&lang=ts"
export * from "./HiddenInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports